import { Text } from "@overmap-ai/blocks"
import { type Asset, UNLABELLED_ASSET_LABEL } from "@overmap-ai/common"
import { selectAssetById } from "@overmap-ai/core"
import { memo } from "react"

import { useAppSelector } from "../../store"
import type { BaseLabelProps } from "./typings"

interface AssetLabelProps extends BaseLabelProps {
	assetId: Asset["uuid"]
}

/** @deprecated Use Text component with asset.label || UNLABELLED_ASSET_LABEL instead */
export const AssetLabel = memo<AssetLabelProps>((props) => {
	const { assetId, ...rest } = props

	const asset = useAppSelector(selectAssetById(assetId))

	return <Text {...rest}>{asset?.label || UNLABELLED_ASSET_LABEL}</Text>
})
AssetLabel.displayName = "AssetLabel"
